import { render, staticRenderFns } from "./oilwear.vue?vue&type=template&id=1f137198&scoped=true&"
import script from "./oilwear.vue?vue&type=script&lang=js&"
export * from "./oilwear.vue?vue&type=script&lang=js&"
import style0 from "./oilwear.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./oilwear.vue?vue&type=style&index=1&id=1f137198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f137198",
  null
  
)

export default component.exports